// extracted by mini-css-extract-plugin
module.exports = {"required":"RequiredAsterisk_required__2WCQu"};